import { render, staticRenderFns } from "./Files.vue?vue&type=template&id=67f510cf&scoped=true&"
import script from "./Files.vue?vue&type=script&lang=js&"
export * from "./Files.vue?vue&type=script&lang=js&"
import style0 from "./Files.vue?vue&type=style&index=0&id=67f510cf&scoped=true&lang=css&"
import style1 from "./Files.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f510cf",
  null
  
)

component.options.__file = "Files.vue"
export default component.exports